import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type PreferredDeliveryMethod = 'pickup' | 'delivery';

interface ShopCheckoutPrefsState {
  preferredDeliveryMethod: PreferredDeliveryMethod;
  setPreferredDeliveryMethod: (method: PreferredDeliveryMethod) => void;
}

const STORAGE_KEY = 'shop-checkout-prefs-v1';

export const useShopCheckoutPrefsStore = create<ShopCheckoutPrefsState>()(
  persist(
    (set) => ({
      preferredDeliveryMethod: 'pickup',
      setPreferredDeliveryMethod: (method) => set({ preferredDeliveryMethod: method }),
    }),
    {
      name: STORAGE_KEY,
    }
  )
);
